export function normalizeGoogleAvatarUrl(url?: string, size: number = 256): string {
  if (!url) return '';
  let u = url.trim();
  // Force https
  if (u.startsWith('//')) u = 'https:' + u;
  if (u.startsWith('http://')) u = u.replace('http://', 'https://');
  // Normalize size for Google avatars
  if (u.includes('lh3.googleusercontent.com')) {
    // prefer sz param; if exists, replace; else append
    if (/\?sz=\d+$/.test(u)) {
      u = u.replace(/\?sz=\d+$/, `?sz=${size}`);
    } else if (/=s\d+-c$/.test(u)) {
      u = u.replace(/=s\d+-c$/, `=s${size}-c`);
    } else {
      // append one variant
      const hasQuery = u.includes('?');
      u = u + (hasQuery ? `&sz=${size}` : `?sz=${size}`);
    }
  }
  return u;
}
